<ng-template #template>
  <div
    class="card-spacing"
    [ngClass]="['col-lg-' + width, needpaddingLeft ? 'pr-lg-0' : 'p-lg-0']"
    aria-live="assertive"
  >
    <div class="card h-100" [ngClass]="{ 'card-comb-left': width === 8 }">
      <div class="card-body table-responsive-md">
        <div
          *ngIf="data?.title && data.collapsable"
          style="margin-bottom: 0; margin-top: 15px"
        >
          <button
            (click)="changeView()"
            [attr.aria-expanded]="state !== 'default'"
            class="expandbutton"
          >
            <img [@rotatedState]="state" src="img/expand.png" alt="" aria-hidden="true" />
            <h2 style="display: inline">{{ data?.title }}</h2>
          </button>
          <button
            (click)="zoom(data.zoomInfo)"
            class="zoom"
            *ngIf="data.zoomInfo"
            style="border: none; background: none; width: 25px; height: 25px"
            [attr.aria-label]="'Zoom ' + data?.title"
          >
            <img src="img/magnifier.svg" alt="" aria-hidden="true" />
          </button>
        </div>
        <div
          *ngIf="!(data?.title && data.collapsable)"
          style="margin-bottom: 0; margin-top: 15px"
        >
          <h2 style="display: inline">{{ data?.title }}</h2>
          <button
            (click)="zoom(data.zoomInfo)"
            class="zoom"
            *ngIf="data.zoomInfo"
            style="border: none; background: none; width: 25px; height: 25px"
            [attr.aria-label]="'Zoom ' + data?.title"
          >
            <img src="img/magnifier.svg" alt="" aria-hidden="true" />
          </button>
        </div>
        <div [ngClass]="{ hiddenButAccessible: state === 'default' }">
          <table class="table big-table">
            <caption class="screen-reader-only">
              {{
                data?.title
              }}
              <span *ngIf="data?.title && data.collapsable">expanded</span>
            </caption>
            <thead>
              <tr>
                <th scope="col" class="border-0"></th>
                <th
                  scope="col"
                  class="border-0 table-fixed-width"
                  [ngClass]="cssColor"
                  *ngFor="let header of data.headers"
                >
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let serie of data.series"
                class="tablestyle"
                style="font-weight: 100"
              >
                <th
                  class="row-header"
                  scope="row"
                  style="text-align: left"
                  nowrap
                  [ngClass]="serie.style"
                >
                  <button
                    type="button"
                    (click)="zoom(serie.zoomInfo)"
                    class="zoom"
                    *ngIf="serie.zoomInfo"
                    style="border: none; background: none; padding: 0;"
                  >
                    {{ serie.caption }}</button
                  >
                  <span *ngIf="!serie.zoomInfo" [ngClass]="serie.style">
                    {{ serie.caption }}</span
                  >
                </th>
                <td *ngFor="let value of serie.values" [ngClass]="serie.style">
                  {{ value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>
